import { render, staticRenderFns } from "./CmfStep2.vue?vue&type=template&id=522508a8&scoped=true"
import script from "./CmfStep2.vue?vue&type=script&lang=js"
export * from "./CmfStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522508a8",
  null
  
)

export default component.exports